module.exports = __webpack_public_path__ + "img/bg_detail_pannel1.dbbc4d4a.png";